// Zentrale Versionsnummer der Allgemeinen Geschaeftsbedingungen (AGB / GTC).
// Wird vom Registrierungsformular an das Backend gesendet und dort gegen
// EXPECTED_TERMS_VERSION geprueft.
//
// Wenn sich der Inhalt der AGB aendert, hier die Version erhoehen UND die
// gleiche Version in backend/src/handlers/user/registration.rs
// (EXPECTED_TERMS_VERSION) anpassen sowie eine neue HTML-Datei
// public/legal/terms-{locale}-v{version}.html bereitstellen.
//
// Diese Datei unterliegt NICHT der Versionsregel in
// .cursor/rules/versioninc.mdc (die nur src/config/version.js betrifft).

export const TERMS_VERSION = '1.0';
export const TERMS_AVAILABLE_LOCALES = ['de', 'en'];

// Liefert die URL zur HTML-Datei in public/legal/.
// Aufrufbeispiel: termsUrl('de') -> '/legal/terms-de-v1.0.html'
export const termsUrl = (locale, version = TERMS_VERSION) => {
  const safeLocale = TERMS_AVAILABLE_LOCALES.includes(locale) ? locale : 'de';
  return `${process.env.PUBLIC_URL || ''}/legal/terms-${safeLocale}-v${version}.html`;
};
